// prefetchAccreditations.js
import axios from "axios";
import { db } from "./offlineDB";
import { env } from "../constants/env";

// Define all accreditation names
const ACCREDITATION_NAMES = ["SADCAS F134-A", "SADCAS F134-B"];

// Map sections to their corresponding accreditation
const ACCREDITATION_SECTIONS = {
  "SADCAS F134-A": [
    "General requirements",
    "Structural & governance requirements",
    "Introduction",
    "Pre examination process",
    "Resource requirements",
  ],
  "SADCAS F134-B": [
    "Ensuring Results",
    "Equipment",
    "Examination Processes",
    "Facilities Environment",
    "IntroductionB",
    "Nonconforming Work",
    "Personnel",
    "Process Requirements",
    "Reagents Consumables",
    "Reports requirements",
    "Requests Examinations",
    "Sample Receipt",
  ],
};

/**
 * Prefetch all accreditations for all labs in the offline DB
 */
export const prefetchAccreditations = async (token) => {
  if (!navigator.onLine) return;

  try {
    const labs = await db.offlineLabs.toArray();

    for (const lab of labs) {
      for (const name of ACCREDITATION_NAMES) {
        const sections = ACCREDITATION_SECTIONS[name] || [];
        for (const section of sections) {
          await prefetchAccreditationBySection({
            labId: lab.id,
            name,
            section,
            token,
          });
        }
      }
    }

    console.log("✅ Accreditation prefetch complete (A & B)");
  } catch (err) {
    console.error("❌ Prefetch accreditation failed:", err.message);
  }
};

/**
 * Fetch and cache a single accreditation section for a lab + name
 */
const prefetchAccreditationBySection = async ({ labId, name, section, token }) => {
  try {
    const res = await axios.get(`${env.kataApiUrl}/api/accreditation`, {
      params: { labId, section, name },
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.data?.success || !res.data.accreditation) return;

    const accreditation = res.data.accreditation;

    // Look for existing record by compound index
    const existing = await db.offlineAccreditations
      .where("[labId+section+name]")
      .equals([labId, section, name])
      .first();

    if (existing?.offline) {
      console.log(
        `[Prefetch] Skipped ${name} (${section}) — local offline edits exist`
      );
      return;
    }

    const offlineId = existing?.id || accreditation._id || `offline-${crypto.randomUUID()}`;

    // Inline update / insert
    await db.offlineAccreditations.put({
      id: offlineId,
      labId,
      section,
      name,
      auditorId: accreditation.auditorId,
      answers: accreditation.answers,
      offline: false,
      lastSynced: new Date().toISOString(),
      timestamp: Date.now(),
    });

    console.log(`[Prefetch] Cached/Updated ${name} | ${section} | lab ${labId}`);
  } catch (err) {
    console.error(`[Prefetch] Failed ${name} | ${section} | lab ${labId}:`, err.message);
  }
};